export const setTasks = (tasks: any[]) => ({
  type: "SET_TASKS",
  payload: tasks,
});

export const setSelectedModule = (moduleName: any) => ({
  type: "SET_SELECTED_MODULE",
  payload: moduleName,
});